// extracted by mini-css-extract-plugin
module.exports = {"statistic_placeholder":"sales_statistic_placeholder__1dK4l","table_sales_report":"sales_table_sales_report__8gYy8","table-td":"sales_table-td__F40Ay"};